class FooterAccordions extends HTMLElement {
  constructor () {
    super()

    this.triggerEls = this.querySelectorAll(
      '[data-el="footer-accordions.trigger"]'
    )

    this.initialiseAccordions()
  }

  initialiseAccordions () {
    this.triggerEls.forEach(triggerEl => {
      this.handleClick = this.handleClick.bind(this)

      triggerEl.addEventListener('click', this.handleClick)
    })
  }

  handleClick (event) {
    const currentState =
      event.currentTarget.getAttribute('aria-expanded') === 'true'

    event.currentTarget.setAttribute('aria-expanded', !currentState)
    event.currentTarget.nextElementSibling.setAttribute(
      'aria-expanded',
      !currentState
    )
  }
}

customElements.define('footer-accordions', FooterAccordions)
